import { makeAutoObservable } from 'mobx';
import { FiltersMapping, FiltersPages, UserFilters } from '../types';
import apiConfig from '../api/routes';

class Filters{

  filters: FiltersMapping = {
    DEPARTMENT_REPORT: {
      blockOfFilters: [],
      id: 0,
      pageTypeSetting: 'DEPARTMENT_REPORT',
      userId: 0
    },
    ORGANIZATION_REPORT: {
      blockOfFilters: [],
      id: 0,
      pageTypeSetting: 'ORGANIZATION_REPORT',
      userId: 0
    },
    PROJECT_REPORT: {
      blockOfFilters: [],
      id: 0,
      pageTypeSetting: 'PROJECT_REPORT',
      userId: 0
    }
  };
  constructor() {
    makeAutoObservable(this);
  }
  setFilters = async (dto: UserFilters) => {
    const res = await apiConfig.userFiltersService.addFilters(dto);
    this.filters[res.pageTypeSetting] = res;
  };
  getFilters = async (pageName: FiltersPages) => {
    const res =  await apiConfig.userFiltersService.getFilters(pageName);
    this.filters[res.pageTypeSetting] = res;
  };
}

export const FiltersStore = new Filters();